import { cn } from "@/lib/cn";
import { iniciais } from "@/lib/formatar";

export function Avatar({
  nome,
  tamanho = "md",
  className,
}: {
  nome: string;
  tamanho?: "sm" | "md" | "lg";
  className?: string;
}) {
  const t = { sm: "size-7 text-[11px]", md: "size-10 text-[13px]", lg: "size-14 text-base" }[
    tamanho
  ];
  return (
    <span
      aria-hidden
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-full bg-gold-100 font-display font-semibold text-gold-800",
        t,
        className,
      )}
    >
      {iniciais(nome)}
    </span>
  );
}
